import type { IndustrySegment, IProject, ProjectPriority } from '@pulse/shared';

import { apiFetch } from '../../../lib/api-client';
import { extractErrorMessage } from '../../../lib/api-error.util';

// §2 — the Delivery Projects page "Create" button. Pre-Sales projects are created only via
// ProjectRequestService.createProject (see features/presales), never through this endpoint.
export interface CreateDeliveryProjectInput {
  name: string;
  projectKey?: string;
  accountId: string;
  businessUnitId: string;
  priority?: ProjectPriority;
  industrySegment?: IndustrySegment;
  description?: string;
  projectTypeId: string;
  fundingTypeId: string;
  startDate: string;
  targetDate?: string;
  endDate?: string;
  documentFolderLink?: string;
  projectLeadId: string;
  projectManagerId?: string;
  staffing?: { userId: string; startDate?: string; endDate?: string; allocatedHoursPerWeek?: number }[];
  presalesProjectId?: string;
}

export async function createDeliveryProject(data: CreateDeliveryProjectInput): Promise<IProject> {
  const res = await apiFetch('/api/v1/delivery/projects', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error(await extractErrorMessage(res, 'Failed to create project'));
  return res.json() as Promise<IProject>;
}
